// src/hooks/useNativePermission.ts
import { useCallback } from 'react';
type TPermission = 'camera' | 'library' | 'notification' | 'location'

const useNativePermission = () => {
  const checkPermission = (permission: TPermission | TPermission[]) => {
    console.log('checkPermission', permission)
    if (Array.isArray(permission)) {
      const pers = permission.map((perm) => 
        (window as any)[`_APP_${perm.toUpperCase()}_PERMISSION`]
      )

      return pers.every(() => true)
    }

    return (window as any)[`_APP_${permission.toUpperCase()}_PERMISSION`]
  }

  const requestPermission = (
    permission: TPermission | TPermission[],
    callback?: (data: any) => void
  ) => {
    if (Array.isArray(permission)) {
      (window as any)?.webViewRequestPermission(permission);
    }
    (window as any)?.webViewRequestPermission([permission]);

    (window as any)._nativeResponsePermission = (data: any) => {
      if (data.camera) {
        callback?.(data)
      }
      if (data.library) {
        callback?.(data)
      }
      if (data.notification) {
        const dataUpdate = data
        dataUpdate.hasNotification = true
        callback?.(dataUpdate)
      }
    }
  }

  return {
    checkPermission,
    requestPermission,
  }
};

export default useNativePermission;

export const useCheckNotificationPermission = (cb?: () => void, skipCheck?: boolean) => {
  const { checkPermission, requestPermission } = useNativePermission();
  const checkNotificationPermission = useCallback(() => {
    if (skipCheck) {
      cb?.()
      return
    }

    if (!checkPermission('notification')) {
      requestPermission('notification', cb)
    } else {
      cb?.()
    }
  }, [checkPermission, requestPermission, cb, skipCheck])

  return checkNotificationPermission
}

// usage
// import { useCheckNotificationPermission } from 'core/hooks/useNativePermission'
// const checkNotificationPermission = useCheckNotificationPermission(() => {
//  console.log('Notification permission granted')
//  // do something
// }, false)
